import { useField } from "formik";
import React from "react";
import BaseElement from "components/FormElements/BaseElement";
import AutocompleteInput from "components/FormElements/AutocompleteInput";
import { useAuth } from "hooks/Auth";
import { apiGet } from "helpers/Request";
import { transform as authorTransformer } from "schemas/Author";

export default function AuthorsMetaProperty(props) {
    const [field, meta] = useField(props);
    const auth = useAuth();

    const input = (
        <div>
            <div className="rounded bg-white p-4 shadow-sm">
                <AutocompleteInput
                    name={field.name}
                    id={field.name}
                    onRequestSearch={async (term) => {
                        const items = await apiGet(
                            "/v4/search",
                            auth.publication,
                            {
                                keyword: term,
                                per_page: 5,
                                type: "author",
                            }
                        );

                        return authorTransformer(items).map((item) => {
                            return {
                                label: item.name,
                                value: item.uuid,
                            };
                        });
                    }}
                />
            </div>
        </div>
    );

    const label = (
        <label
            htmlFor={props.id}
            className="block text-sm font-medium text-gray-700"
        >
            {props.label}
        </label>
    );

    const helperText = props.helpertext ? (
        <p className="mt-2 text-sm text-gray-500">{props.helpertext}</p>
    ) : (
        ""
    );

    const errorText =
        props.isError || (meta.touched && meta.error) ? (
            <p className="mt-2 text-sm text-red-600">
                {props.errorText}
                {meta.error}
            </p>
        ) : (
            ""
        );

    return (
        <BaseElement
            {...props}
            input={input}
            label={label}
            helpertext={helperText}
            errortext={errorText}
        />
    );
}

export const Property = AuthorsMetaProperty;

export const Label = "Authors";
